import FromDialog from "../../FormModal";
import styles from "./index.module.less";
export default function BigEnterprises({ config, isMobile }) {
  const icon =
    "https://grocery-cdn.huaban.com/file/769aa030-f0a1-11ee-97bf-8784330ff257.png";
  const order = () => {
    FromDialog.open({
      config,
      isMobile,
    });
  };
  return (
    <div
      className={styles.sceneConent}
      style={{
        backgroundImage: `url(${
          isMobile
            ? config?.contentImgMobile?.[0].url
            : config?.contentImg?.[0]?.url
        })`,
      }}
    >
      {/* <div className={styles.header}>
        <div className={styles.title}>大型企业商用</div>
        <div className={styles.desc}>
          1.3亿版权图片/全球商用授权/正版授权书在线下载/线下印刷数量定制
        </div>
      </div> */}

      <div className={styles.cardContent}>
        {config?.scene?.map((item, index) => {
          return (
            <div key={index} className={styles.card}>
              <div>
                <div className={styles.cardTitle}>{item.title}</div>
                <div className={styles.cardDesc}>{item.desc}</div>
                <div className={styles.tagConent}>
                  {item?.tags?.map((tag, index) => {
                    return (
                      <div className={styles.tag} key={index}>
                        <img src={icon} alt="" width={20} />
                        {tag}
                      </div>
                    );
                  })}
                </div>
              </div>

              <div
                className={styles.order}
                onClick={order}
                data-gd-click="button_click"
                data-gd-expose="button_expose"
                data-module-name="商品展示栏"
                data-subject-name="按钮"
                data-button-name="立即定制"
              >
                <span>立即定制</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
